import { render, staticRenderFns } from "./OrderArrival.vue?vue&type=template&id=05891738&scoped=true&"
import script from "./OrderArrival.vue?vue&type=script&lang=js&"
export * from "./OrderArrival.vue?vue&type=script&lang=js&"
import style0 from "./OrderArrival.vue?vue&type=style&index=0&id=05891738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05891738",
  null
  
)

export default component.exports